import React from "react";
import BigButton from "./BigButton";

function HeaderSearch(props) {
    const { setActiveKey } = props;
    return (
        <div className="trpr-sf-header-search">
            <BigButton onClick={() => setActiveKey("search-by-region")} iconName="gpx">
                Search by Region and Tags
            </BigButton>
            <BigButton onClick={() => setActiveKey("search-by-stop")} iconName="marker">
                Search by Stop
            </BigButton>
        </div>
    );
}

export default HeaderSearch;
